import { useSpyOnFieldValue } from 'hooks/form-spy/useSpyOnFieldValue';
import { useEffect } from 'react';
import { useForm } from 'react-final-form';
import { usePrevious } from 'react-use';

type UseBlurFinalFormOnChangeProps = {
  name: string;
  disabled?: boolean;
  fieldPathToBlur?: string;
};

/**
 * Helper hook to trigger validation when changing a final form value
 * - Only necessary for heavier forms that use `validateOnBlur`
 * - Should be single-action inputs, like radio buttons, selects, or checkboxes
 * - Don't use for text inputs!
 * - Could update with a debounce if we want to use it for text inputs
 */
export const useBlurFinalFormOnChange = ({ name, disabled = false, fieldPathToBlur }: UseBlurFinalFormOnChangeProps) => {
  const formApi = useForm();
  const fieldValue = useSpyOnFieldValue({
    fieldPath: name,
  });
  const previousFieldValue = usePrevious(fieldValue);

  useEffect(() => {
    if (!disabled && fieldValue !== previousFieldValue) {
      formApi.blur(fieldPathToBlur ?? name);
    }
  }, [
    disabled,
    fieldPathToBlur,
    fieldValue,
    formApi,
    name,
    previousFieldValue,
  ]);
};
